import axiosBase from "@/api/axiosBase";

const state = {
    globalDBStyle:{},
    //     'mapCate':'无',
    //     'displayCate':'list',
    //     //Point
    //     '气象数据':{
    //         'bzField':'station_name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 1)',
    //         'fillCate':1,
    //         'fillField':'station_type',
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(255, 0, 0, 0.8)',
    //         'pMark':3,
    //         'pSize':10
    //     },
    //     '环境监测数据':{
    //         'bzField':'station_name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 1)',
    //         'fillCate':1,
    //         'fillField':'station_type',
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)',
    //         'pMark':'square',
    //         'pSize':10
    //     },
    //     '水利设施运行数据':{
    //         'bzField':'station_name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':1,
    //         'fillField':'station_type',
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)',
    //         'pMark':5,
    //         'pSize':10
    //     },
    //     '污染源数据':{
    //         'bzField':'station_name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':1,
    //         'fillField':'station_type',
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)',
    //         'pMark':'4',
    //         'pSize':10
    //     },
    //     '人口':{
    //         'bzField':'station_name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':0,
    //         'fillField':'station_type',
    //         'fillColor':'rgba(122, 175, 105, 0.8)',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)',
    //         'pMark':'dTrig',
    //         'pSize':10
    //     },
    //     '畜禽':{
    //         'bzField':'station_name',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':0,
    //         'fillField':'station_type',
    //         'fillColor':'rgba(122, 175, 105, 0.8)',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)',
    //         'pMark':'circle',
    //         'pSize':10
    //     },
    //     //Line
    //     '河流沟渠':{
    //         'bzField':'河流编号',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':0,
    //         'strokeWidth':3,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)',
    //         'strokeArrow':0
    //     },
    //     //Polygon
    //     '行政区划':{
    //         'bzField':'行政村名称',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':0,
    //         'fillField':'',
    //         'fillColor':'rgba(125, 240, 175, 0.5)',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': false,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)'
    //     },
    //     '土壤':{
    //         'bzField':'土壤类型',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':1,
    //         'fillField':'土壤类型',
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)'
    //     },
    //     '土地利用':{
    //         'bzField':'土地利用类型',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':1,
    //         'fillField':'土地利用类型',
    //         'fillColor':'red-green-blue',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)'
    //     },
    //     '湖库坑塘':{
    //         'bzField':'库塘名称',
    //         'bzFontSize':10,
    //         'bzColor':'rgba(0, 0, 0, 0.7)',
    //         'fillCate':0,
    //         'fillField':'',
    //         'fillColor':'rgba(125, 240, 175, 0.5)',
    //         'fillOpacity':1,
    //         'strokeWidth':1,
    //         'strokeColorToFillColor': true,
    //         'strokeColor': 'rgba(122, 122, 122, 0.8)'
    //     },
    //     'DEM':{
    //         'fillCate':2,
    //         'fillColor':'black-white'
    //     }        
    // },
    dbStyle: {},
}

const getters = {

}

const actions = {

}

const mutations = {
    //设置文件或者文件夹已设置样式
    setFileStyle(state, changeStyle){
        state.dbStyle[changeStyle.fileId] = changeStyle.style;
    },
    //标注显示字段更改
    setBZField(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        }        
        state.dbStyle[changeStyle.fileId].bzField = changeStyle.value;
    },
    //标注字号更改
    setBZFontSize(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].bzFontSize = changeStyle.value;
    },
    //标注颜色更改
    setBZColor(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].bzColor = changeStyle.value;
    },
    //样式类型更改
    setFillCate(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].fillCate = changeStyle.value;
    },
    //填充Field更改
    setFillField(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].fillField = changeStyle.value;
    },
    //填充颜色更改
    setFillColor(state, changeStyle){
        console.log(state, changeStyle)
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].fillColor = changeStyle.value;
    },
    setFillOpacity(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].fillOpacity = changeStyle.value;
    },
    //边线粗细更改
    setStrokeWidth(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].strokeWidth = changeStyle.value;
    },
    //边线颜色更改
    setStrokeColor(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].strokeColor = changeStyle.value;
    },
    //边线颜色是否与填充颜色相同
    setStrokeColorToFillColor(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].strokeColorToFillColor = changeStyle.value;
    },
    //线样式更改
    setStrokeArrow(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].strokeArrow = changeStyle.value;
    },
    //点样式更改
    setPointMark(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].pMark = changeStyle.value;
    },
    //点大小更改
    setPointSize(state, changeStyle){
        if(!state.dbStyle.hasOwnProperty(changeStyle.fileId)){
            state.dbStyle[changeStyle.fileId] = JSON.parse(JSON.stringify(state.globalDBStyle[changeStyle.cate]));
        } 
        state.dbStyle[changeStyle.fileId].pSize = changeStyle.value;
    },

    setDefaultStyle(state, defaultStyle){
        state.globalDBStyle = defaultStyle;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}